/* ============================================================
   Senchado 2.0 — 出荷表示 共通部品（純関数 ＋ DOM init）
   出典: assets/senchado-product-hero.js（TRANSIT_DAYS / getRegionFromPrefecture /
         initShippingCountdown / showArrivalEstimate / requestLocation）
   仕様SSOT: docs/spec-article-products.md §Sprint 1 / 決裁記録1・4
   契約テスト: tests/senchado-shipping.test.mjs
   ------------------------------------------------------------
   純関数（Node から import 可能・window/document 非依存）:
     computeCountdown(nowMinutes, cutoffMinutes)
         → { before, diffMinutes, hours, minutes, timeStr, label }
     getRegionFromPrefecture(pref)                    → 地方名（不明は '関東'）
     transitDays(region)                              → 配送日数（不明は 1）
     computeArrival(now: Date, region, cutoffMinutes) → Date（土日祝無視・now 非破壊）
     formatArrival(date: Date)                        → 'M月D日（曜）'
   締切は引数 cutoffMinutes 駆動（11:30 をハードコードしない）。
   挙動は現行商品ヒーローと完全同等（土日祝・休業日は見ない・端末時刻基準）。

   ブラウザでは window.SenchadoShipping に公開し、DOMContentLoaded で
     [data-ss-countdown] … カウントダウン点灯
     [data-ss-arrival-btn] … クリックで geolocation→逆ジオ→お届け日表示
   を配線する。cutoff は各要素の祖先 [data-cutoff-hour] / [data-cutoff-minute] から読む。
   ============================================================ */

(function () {
  'use strict';

  // 同一ページに複数設置されscriptタグが重複しても、二重定義・イベント二重バインドさせない
  if (typeof window !== 'undefined' && window.SenchadoShipping) { return; }

  var WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

  // 都道府県 → 地方（hero SSOT を verbatim 移植・不明は関東）
  var PREF_TO_REGION = {
    '北海道': '北海道',
    '青森県': '東北', '岩手県': '東北', '宮城県': '東北', '秋田県': '東北', '山形県': '東北', '福島県': '東北',
    '茨城県': '関東', '栃木県': '関東', '群馬県': '関東', '埼玉県': '関東', '千葉県': '関東', '東京都': '関東', '神奈川県': '関東',
    '新潟県': '北陸', '富山県': '北陸', '石川県': '北陸', '福井県': '北陸',
    '山梨県': '中部', '長野県': '中部', '岐阜県': '中部', '静岡県': '中部', '愛知県': '中部',
    '三重県': '関西', '滋賀県': '関西', '京都府': '関西', '大阪府': '関西', '兵庫県': '関西', '奈良県': '関西', '和歌山県': '関西',
    '鳥取県': '中国', '島根県': '中国', '岡山県': '中国', '広島県': '中国', '山口県': '中国',
    '徳島県': '四国', '香川県': '四国', '愛媛県': '四国', '高知県': '四国',
    '福岡県': '九州', '佐賀県': '九州', '長崎県': '九州', '熊本県': '九州', '大分県': '九州', '宮崎県': '九州', '鹿児島県': '九州',
    '沖縄県': '沖縄',
  };

  // 地方 → 配送日数（hero 既定表 verbatim・不明は 1）
  var TRANSIT_DAYS = {
    関東: 1, 中部: 1, 関西: 1, 東北: 1, 北陸: 1,
    中国: 2, 四国: 2, 九州: 2, 北海道: 2, 沖縄: 3,
  };

  // カウントダウン算出。hero initShippingCountdown の計算部を純関数化。
  //   before = now < cutoff。締切前は「締切まで」、締切後は「翌締切まで（24時間ロール）」。
  function computeCountdown(nowMinutes, cutoffMinutes) {
    var before = nowMinutes < cutoffMinutes;
    var diff = before
      ? cutoffMinutes - nowMinutes
      : (24 * 60 - nowMinutes) + cutoffMinutes;
    var hours = Math.floor(diff / 60);
    var minutes = diff % 60;
    var timeStr = '';
    if (hours > 0) timeStr += hours + '時間';
    if (minutes > 0) timeStr += minutes + '分';
    var label = before ? '当日出荷' : 'あす出荷';
    return { before: before, diffMinutes: diff, hours: hours, minutes: minutes, timeStr: timeStr, label: label };
  }

  function getRegionFromPrefecture(pref) {
    return PREF_TO_REGION[pref] || '関東';
  }

  function transitDays(region) {
    return TRANSIT_DAYS[region] || 1;
  }

  // お届け日算出。hero showArrivalEstimate の日付計算部を純関数化。
  //   締切後（now >= cutoff）は出荷日を翌日にずらし、地方の配送日数を足す。
  //   now は破壊しない（コピーから計算）。土日祝・休業日は考慮しない（現行同等）。
  function computeArrival(now, region, cutoffMinutes) {
    var transit = transitDays(region);
    var shipDate = new Date(now.getTime());
    var nowMin = now.getHours() * 60 + now.getMinutes();
    if (nowMin >= cutoffMinutes) {
      shipDate.setDate(shipDate.getDate() + 1);
    }
    var arrival = new Date(shipDate.getTime());
    arrival.setDate(arrival.getDate() + transit);
    return arrival;
  }

  function formatArrival(date) {
    return (date.getMonth() + 1) + '月' + date.getDate() + '日（' + WEEKDAYS[date.getDay()] + '）';
  }

  var API = {
    computeCountdown: computeCountdown,
    getRegionFromPrefecture: getRegionFromPrefecture,
    transitDays: transitDays,
    computeArrival: computeArrival,
    formatArrival: formatArrival,
  };

  // --- Node / CommonJS へエクスポート（契約テストはここから取得） ---
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = API;
  }

  // --- ブラウザ公開（hero.js が委譲先として参照） ---
  if (typeof window !== 'undefined') {
    window.SenchadoShipping = API;
  }

  // --- DOM init（ブラウザのみ。Node import 時は実行されない） ---
  if (typeof document !== 'undefined') {
    var DEFAULT_CUTOFF_H = 11;
    var DEFAULT_CUTOFF_M = 30;

    // cutoff（分）を要素の祖先 [data-cutoff-hour]/[data-cutoff-minute] から読む。
    function readCutoffMinutes(el) {
      var holder = (el.closest && el.closest('[data-cutoff-hour]')) || el;
      var h = parseInt(holder.getAttribute('data-cutoff-hour'), 10);
      var m = parseInt(holder.getAttribute('data-cutoff-minute'), 10);
      if (!Number.isFinite(h)) h = DEFAULT_CUTOFF_H;
      if (!Number.isFinite(m)) m = DEFAULT_CUTOFF_M;
      return h * 60 + m;
    }

    function renderCountdown(el) {
      var cutoff = readCutoffMinutes(el);
      var now = new Date();
      var r = computeCountdown(now.getHours() * 60 + now.getMinutes(), cutoff);
      el.innerHTML =
        '<span class="ss-countdown__time">あと' + r.timeStr + '</span>以内のご注文で<strong>' + r.label + '</strong>';
      el.hidden = false;
    }

    function arrivalTargetFor(btn) {
      var root = (btn.closest && btn.closest('[data-ss-root]')) || document;
      return root.querySelector('[data-ss-arrival]');
    }

    function showArrival(btn, pref, region) {
      var target = arrivalTargetFor(btn);
      var cutoff = readCutoffMinutes(btn);
      var arrival = computeArrival(new Date(), region, cutoff);
      var dateStr = formatArrival(arrival);
      if (target) {
        target.innerHTML = pref + 'へ最短 <strong>' + dateStr + '</strong> にお届け';
        target.hidden = false;
        target.classList.add('is-visible');
      }
      btn.hidden = true;
    }

    function requestArrival(btn) {
      btn.textContent = '取得中...';
      btn.disabled = true;
      if (!navigator.geolocation) {
        showArrival(btn, '東京都', '関東');
        return;
      }
      // getCurrentPosition の timeout は許可プロンプト保留中はカウントされず、プロンプトが
      // 無視/静音化されると「取得中...」のまま無言で待たされる。2.5秒で東京都基準の結果を
      // 先に出し、後から位置が取れたら実際の都道府県で上書きする（谷本FB 2026-07-28）
      var provisional = setTimeout(function () {
        showArrival(btn, '東京都', '関東');
      }, 2500);
      function finish(pref, region) {
        clearTimeout(provisional);
        showArrival(btn, pref, region);
      }
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var url = 'https://nominatim.openstreetmap.org/reverse?lat=' + pos.coords.latitude +
            '&lon=' + pos.coords.longitude + '&format=json&accept-language=ja';
          // 逆ジオコーダにも5秒タイムアウト（fetch宙吊りで確定しないのを防ぐ）
          var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
          var abortTimer = ctrl ? setTimeout(function () { ctrl.abort(); }, 5000) : null;
          fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (abortTimer) clearTimeout(abortTimer);
              var pref = (d.address && (d.address.province || d.address.state)) || '東京都';
              finish(pref, getRegionFromPrefecture(pref));
            })
            .catch(function () {
              if (abortTimer) clearTimeout(abortTimer);
              finish('東京都', '関東');
            });
        },
        function () { finish('東京都', '関東'); },
        { timeout: 8000 }
      );
    }

    function init() {
      var countdowns = document.querySelectorAll('[data-ss-countdown]');
      for (var i = 0; i < countdowns.length; i++) {
        renderCountdown(countdowns[i]);
      }
      var buttons = document.querySelectorAll('[data-ss-arrival-btn]');
      for (var j = 0; j < buttons.length; j++) {
        (function (btn) {
          btn.addEventListener('click', function () { requestArrival(btn); });
        })(buttons[j]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();
